import { FC } from 'react';
import './HeaderNavigator.css';
import { IconLogo } from '../Icons/IconLogo';
import { useTranslation } from 'react-i18next';

import {
	IconHome,
	IconPreparacion,
	IconCostosPrecios,
	IconMercado,
	IconNovedades,
	IconSobreNosotros,
	IconTestExportador,
	IconCompilanceModule,
	IconLimiteDiario,
	IconCalcuFob,
	IconCalcuPaletizado,
	IconCalcuPrecios,
	IconFeriasInternacionales,
	IconComparadorPrecios,
	IconNoticias,
	IconSugerencias,
	IconQuienesSomos,
	IconOtrosServicios,
} from '../Icons';
import { Link } from 'react-router-dom';

const HeaderNavigator: FC = () => {
	const { t } = useTranslation();
	return (
		<div className="header-navigator">
			<div className="header-navigator__logo">
				<Link to="/">
					<IconLogo />
				</Link>
			</div>
			<div className="header-navigator__items">
				<Link
					className={`header-navigator__item ${window.location.pathname === '/' || window.location.pathname === '/home' ? 'active' : ''}  `}
					to="/">
					<IconHome className="header-navigator__item__icon" />
					<span className="header-navigator__item__text">{t('navigation.home')}</span>
				</Link>
				<div className="header-navigator__heading">
					<span className="header-navigator__heading__text">{t('navigation.tools')}</span>
				</div>
				<div className={`header-navigator__item  ${window.location.pathname === '/exportertest' ? 'active' : ''}`}>
					<IconPreparacion className="header-navigator__item__icon" />
					<span className="header-navigator__item__text">{t('navigation.preparation')}</span>
					<div className="header-navigator__container">
						<div className="header-navigator__content">
							<div className="header-navigator__content__item">
								<span className="header-navigator__heading__text">{t('navigation.preparation_and_compliance')}</span>
								<Link
									to="/exportertest"
									className="header-navigator__button">
									<div className="header-navigator__button__icon">
										<IconTestExportador
											width={35}
											height={35}
										/>
									</div>
									<span className="header-navigator__button__text">{t('navigation.test_exportador')}</span>
								</Link>
								<div className="header-navigator__button">
									<div className="header-navigator__button__icon">
										<IconCompilanceModule />
									</div>
									<span className="header-navigator__button__text">{t('navigation.compliance_module')}</span>
								</div>
								<div className="header-navigator__button">
									<div className="header-navigator__button__icon">
										<IconLimiteDiario />
									</div>
									<span className="header-navigator__button__text">{t('navigation.limits')}</span>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div
					className={`header-navigator__item ${window.location.pathname === '/cubicaje' || window.location.pathname === '/calcularprecios' ? 'active' : ''}`}>
					<IconCostosPrecios className="header-navigator__item__icon" />
					<span className="header-navigator__item__text">{t('navigation.costs_and_prices')}</span>
					<div className="header-navigator__container">
						<div className="header-navigator__content">
							<div className="header-navigator__content__item">
								<span className="header-navigator__heading__text">{t('navigation.costs_and_prices')}</span>
								<div className="header-navigator__button">
									<div className="header-navigator__button__icon">
										<IconCalcuFob />
									</div>
									<span className="header-navigator__button__text">{t('navigation.calculate_fob')}</span>
								</div>
								<Link
									to="/cubicaje"
									className="header-navigator__button">
									<div className="header-navigator__button__icon">
										<IconCalcuPaletizado />
									</div>
									<span className="header-navigator__button__text">{t('navigation.palletized_calculator')}</span>
								</Link>
								<Link
									to="/calcularprecios"
									className="header-navigator__button">
									<div className="header-navigator__button__icon">
										<IconCalcuPrecios />
									</div>
									<span className="header-navigator__button__text">{t('navigation.price_calculator')}</span>
								</Link>
							</div>
						</div>
					</div>
				</div>

				<div className={`header-navigator__item ${window.location.pathname === '/pricecomparator' ? 'active' : ''}`}>
					<IconMercado className="header-navigator__item__icon" />
					<span className="header-navigator__item__text">{t('navigation.markets')}</span>
					<div className="header-navigator__container">
						<div className="header-navigator__content">
							<div className="header-navigator__content__item">
								<span className="header-navigator__heading__text">{t('navigation.markets_expansion')}</span>
								<div className="header-navigator__button">
									<div className="header-navigator__button__icon">
										<IconFeriasInternacionales />
									</div>
									<span className="header-navigator__button__text">{t('navigation.ferias_international')}</span>
								</div>
								<Link
									to="/pricecomparator"
									className="header-navigator__button">
									<div className="header-navigator__button__icon">
										<IconComparadorPrecios />
									</div>
									<span className="header-navigator__button__text">{t('navigation.price_comparator')}</span>
								</Link>
							</div>
						</div>
					</div>
				</div>

				<div className="header-navigator__heading">
					<span className="header-navigator__heading__text">{t('navigation.resources')}</span>
				</div>
				<div
					className={`header-navigator__item ${window.location.pathname === '/noticias' || window.location.pathname === '/sugerencias' ? 'active' : ''}`}>
					<IconNovedades className="header-navigator__item__icon" />
					<span className="header-navigator__item__text">{t('navigation.news')}</span>
					<div className="header-navigator__container">
						<div className="header-navigator__content">
							<div className="header-navigator__content__item">
								<span className="header-navigator__heading__text">{t('navigation.news')}</span>
								<Link
									to="/search"
									className="header-navigator__button">
									<div className="header-navigator__button__icon">
										<IconNoticias />
									</div>
									<span className="header-navigator__button__text">{t('navigation.noticias')}</span>
								</Link>
								<div className="header-navigator__button">
									<div className="header-navigator__button__icon">
										<IconSugerencias />
									</div>
									<span className="header-navigator__button__text">{t('navigation.suggestions')}</span>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div className="header-navigator__item">
					<IconSobreNosotros className="header-navigator__item__icon" />
					<span className="header-navigator__item__text">{t('navigation.about_us')}</span>
					<div className="header-navigator__container">
						<div className="header-navigator__content">
							<Link
								to="/acerca-interconectar"
								className="header-navigator__content__item">
								<span className="header-navigator__heading__text">{t('navigation.about_us')}</span>
								<div className="header-navigator__button">
									<div className="header-navigator__button__icon">
										<IconQuienesSomos />
									</div>
									<span className="header-navigator__button__text">{t('navigation.who_we_are')}</span>
								</div>
								<Link
									to="/servicios"
									className="header-navigator__button">
									<div className="header-navigator__button__icon">
										<IconOtrosServicios />
									</div>
									<span className="header-navigator__button__text">{t('navigation.other_services')}</span>
								</Link>
							</Link>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};

export default HeaderNavigator;
